module.exports = __webpack_public_path__ + "img/selector_3_selected.8be10cce.png";